import enCommon from './locales/en/common.json';
import enExemple from './locales/en/exemple.json';
import enFiles from './locales/en/files.json';
import enMap from './locales/en/map.json';
import frCommon from './locales/fr/common.json';
import frExemple from './locales/fr/exemple.json';
import frFiles from './locales/fr/files.json';
import frMap from './locales/fr/map.json';

/** Un namespace par domaine fonctionnel (même découpage que src/features). */
export const resources = {
    fr: { common: frCommon, exemple: frExemple, files: frFiles, map: frMap },
    en: { common: enCommon, exemple: enExemple, files: enFiles, map: enMap },
} as const;

export const defaultNS = 'common';

export const namespaces = Object.keys(resources.fr) as (keyof (typeof resources)['fr'])[];
